
import { combineReducers } from 'redux';
import notifications from 'notifications/redux/notifications/reducers';

const reducers = combineReducers({
    notifications,
});

export default reducers;